import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '../global';


export interface TestPostRequest {
  Usuario: string;
  Password: string;
}


export interface TestPostResponse {
  message: string;
  status?: string;
}

@Injectable({
  providedIn: 'root'
})

export class ResetPasswordService {

  private API_URL = Global.url + '/reset'; 

  constructor(private http: HttpClient) {}

  sendData(body: TestPostRequest): Observable<TestPostResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post<TestPostResponse>(`${this.API_URL}/password`, body, { headers , withCredentials: true});
  }

  logout(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http.post<any>(`${this.API_URL}/logout`, {}, { headers, withCredentials: true })
  }
  
}


